(function () {

  // ─── APUFUNKTIOT ───────────────────────────────────────────


  function attachLimits(component, minQty, maxQty) {
    const input = component.querySelector('input[name="quantity"], input[name="updates[]"]');
    if (!input) return;

    if (minQty) {
      input.min = minQty;
      if (parseInt(input.value) < minQty) input.value = minQty;
    }

    function enforce() {
      const val = parseInt(input.value) || 0;
      if (minQty && val < minQty) input.value = minQty;
      if (maxQty && val > maxQty) input.value = maxQty;
    }

    input.addEventListener('change', enforce);
    input.addEventListener('input', enforce);
    input.addEventListener('blur', enforce);

    const plusBtn = component.querySelector('[name="plus"]');

      if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        setTimeout(function () {
          const val = parseInt(input.value) || 0;
          if (maxQty && val > maxQty) {
            input.value = maxQty;
            input.dataset.cartQuantity = maxQty; // pakota Horizonin oma arvo
            input.dispatchEvent(new Event('change', { bubbles: true }));
            input.dispatchEvent(new Event('blur', { bubbles: true })); // pakota Horizon päivittämään
            alert('Tätä tuotetta voidaan tilata enintään ' + maxQty + ' kpl kerrallaan.');
          }
        }, 100); // kasvatettu 50 → 100ms
      });
    }

    const form = input.closest('form');
    if (form) {
      const addBtn = form.querySelector('[type="submit"], [name="add"]');
      function validate(e) {
        const qty = parseInt(input.value);
        if (minQty && qty < minQty) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert('Tätä tuotetta voidaan tilata vähintään ' + minQty + ' kpl kerrallaan.');
          return false;
        } else if (maxQty && qty > maxQty) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert('Tätä tuotetta voidaan tilata enintään ' + maxQty + ' kpl kerrallaan.');
          return false;
        }
      }
      form.addEventListener('submit', validate, true);
      if (addBtn) addBtn.addEventListener('click', validate, true);
    }
  }

  // ─── TUOTESIVU ─────────────────────────────────────────────

  function initProductPage() {
    const minQty = parseInt(window.__minQty) || 0;
    const maxQty = parseInt(window.__maxQty) || 0;
    if (!minQty && !maxQty) return;

    const component = document.querySelector('quantity-selector-component');
    if (component) attachLimits(component, minQty, maxQty);
  }

  // ─── OSTOSKORI ─────────────────────────────────────────────

  function initCart() {
  document.querySelectorAll('[data-cart-item-limits]').forEach(function (el) {
    const variantId = el.dataset.variantId;
    const minQty = parseInt(el.dataset.min) || 0;
    const maxQty = parseInt(el.dataset.max) || 0;
    if (!minQty && !maxQty) return;

    const component = document.querySelector(
      'cart-quantity-selector-component[data-variant-id="' + variantId + '"]'
    );
    // Älä rekisteröi uudelleen jos jo tehty
    if (component && !component.dataset.limitsAttached) {
      component.dataset.limitsAttached = 'true';
      attachLimits(component, minQty, maxQty);
    }
  });
}


  // Kuuntele DOM-muutoksia — drawer latautuu dynaamisesti
  const observer = new MutationObserver(function () {
    if (document.querySelector('[data-cart-item-limits]')) {
      initCart();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ─── KÄYNNISTYS ────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    initProductPage();
    initCart();
  });

})();
